module.exports = __webpack_public_path__ + "MetaWebPro-Book.2be3d471fe0f4b6e5d8b.woff";


//////////////////
// WEBPACK FOOTER
// /var/data/workspace/hess/hess_smart_city_web/src/assets/fonts/MetaWebPro-Book.woff
// module id = ../../../../../src/assets/fonts/MetaWebPro-Book.woff
// module chunks = styles